import { render } from "./editrow.vue?vue&type=template&id=2383d463&scoped=true"
import script from "./editrow.vue?vue&type=script&lang=js"
export * from "./editrow.vue?vue&type=script&lang=js"

import "./editrow.vue?vue&type=style&index=0&id=2383d463&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2383d463"]])

export default __exports__